// The Vietnamese words (D31, R10-Q16): typed by the English keys, so a missing one fails the
// build. Glossary: web/src/i18n/GLOSSARY.md.

import type { Dict } from "../en";
import { admin } from "./admin";
import { auto } from "./auto";
import { chat } from "./chat";
import { common } from "./common";
import { inbox } from "./inbox";
import { me } from "./me";
import { mem } from "./mem";
import { msg } from "./msg";
import { shell } from "./shell";

export const vi: Dict = { common, shell, chat, msg, inbox, auto, admin, mem, me };
